import { z } from 'zod';
import { SelfExclusionNotificationEntitySchema } from 'src_server/types/notificationData';

const actionType = z.union([
    z.literal('close'),
    z.literal('unassign'), //available but not used so far
    z.literal('assign'),
]);

const entityType = z.union([
    // z.literal('matched-account'),
    // z.literal('payment-declines'),
    // z.literal('matched-payment-methods'),
    // z.literal('review-account'),
    // z.literal('call-credit-age-verification'),
    z.literal('call-credit-validation-errors'), //available but not used so far
    // z.literal('gamstop-account-not-longer-blocked'),
    z.literal('gamstop-positive'),
    z.literal('gamstop-negative'),
    z.literal('moh-popup-triggered'),
    SelfExclusionNotificationEntitySchema,
    // z.literal('affordability-excluded'),
    z.literal('call-credit-pep-verification'),
]);

export const InputSchema = z.object({
    entity: entityType,
    action: actionType,
    id: z.string(),
});

//  type InputSchemaType = z.infer<typeof InputSchema>;

export const ErrorResponseSchema = z.object({
    code: z.string(),
    message: z.string(),
    debugDetails: z.string(),
});
type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success' }
    | { responseStatus: 'error'; data: ErrorResponseType }
    | {
          responseStatus: 'apiError';
          status: number;
          data?: unknown;
      };
